module.exports = __webpack_public_path__ + "img/mNavCancel.117607ab.svg";